import React, { useState, useEffect } from "react";
import RegisterCard from "./components/RegisterCard";
import CardList from "./components/CardList";
import AdminPanel from "./components/admin/AdminPanel";
import "./telegram/TelegramApp.css";
import "./telegram/cards.css";

const App = () => {
  const [view, setView] = useState("register");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get("action");

    switch (action) {
      case "register":
        setView("register");
        break;
      case "cards":
        setView("cards");
        break;
      case "admin":
        setView("admin");
        break;
      default:
        setView("register");
    }
  }, []);

  if (view === "admin") {
    return <AdminPanel />;
  }

  return (
    <div className="tg-app">
      {view === "register" ? <RegisterCard /> : <CardList />}
    </div>
  );
};

export default App;
